// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AegC","col":"styles_col__3Mv8o"};